import { BasicRuleInput } from "./BasicRuleInput/BasicRuleInput";
import { ComplexRuleInput } from "./ComplexRuleInput/ComplexRuleInput";

export const RuleInput = props => {
  if (!props.rule.GetIsComplex()) {
    return (
      <BasicRuleInput
        dataTestIdPrefix={props.dataTestIdPrefix}
        allowHierarchyFields={props.allowHierarchyFields}
        editing={props.editing}
        rule={props.rule}
        setRule={props.setRule}
        chartData={props.chartData}
        errorsObject={props.errorsObject}
        {...props.basicRuleInputProps}
      />
    );
  }

  return (
    <ComplexRuleInput
      dataTestIdPrefix={props.dataTestIdPrefix}
      allowHierarchyFields={props.allowHierarchyFields}
      editing={props.editing}
      rule={props.rule}
      setRule={props.setRule}
      errorsObject={props.errorsObject}
    />
  );
};
